import { useState } from "react";
import queryString from "query-string";
import "./../../assets/scss/requisition/index.scss";
import { ViewIcon } from "../Icons";
import { useQuery } from "react-query";
import { fetchActionsUtil } from "../../utils/helpers";
import { useAuth } from "../../hooks/useAuth";
import RFQCompanyModal from "../RFQCompanyModal";

export default function ViewQuotes({ requisition }) {
  const { backendUrl } = useAuth();

  const requestid = requisition?.parentRequisitionId;

  const [showCreateQuoteModal, setShowCreateQuoteModal] = useState(false);

  const { data } = useQuery(
    ["GET_COMPANY_RFQ_FROM_REQUISITION", requestid],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/vendors/company-RFQ?${queryString.stringify({
          requestid,
        })}`,
      ),
    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  return (
    <div>
      <button
        className="btn btn-primary"
        onClick={() => setShowCreateQuoteModal(true)}
      >
        <span className="mx-3">
          <ViewIcon color="#FFF" />
        </span>
        View Quotes
      </button>

      {showCreateQuoteModal && (
        <RFQCompanyModal
          show={showCreateQuoteModal}
          onHide={setShowCreateQuoteModal}
          selectedRFQ={data}
          disableInput={true}
          headerNo={`RFQ No : ${data?.RFQId}`}
          headerName={`RFQ Name : ${data?.formName}`}
          theRFQName={data?.formName}
          requisition={requisition}
        />
      )}
    </div>
  );
}
// RFQId
